import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/training/$sessionId')({

}).lazy(() => import('./$sessionId.lazy').then((d) => d.Route));
